<template>
  <div class="login-box">
    <div>
      <div class="body">
        <!-- <div class="left"></div> -->
        <div class="right">
          <div class="tips">数字乡村建设监测平台</div>
          <el-form
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
            label-width="0px"
          >
            <el-form-item prop="loginName">
              <el-input
                v-model="loginForm.loginName"
                placeholder="请输入账号"
                style="border-radius: 20px"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                placeholder="请输入密码"
                v-model="loginForm.password"
                @keyup.enter.native="submit()"
                style="border-radius: 20px"
              ></el-input>
            </el-form-item>

            <!-- 验证码 -->
            <div class="smsCode" v-if="isPhone">
              <el-input
                type="text"
                style="width: 125px"
                v-model="smsCode"
                placeholder="请输入验证码"
              />
              <el-button
                type="primary"
                :disabled="noSend"
                style="height: 40px !important"
                @click="getCode()"
                >{{ SendCode_text }}</el-button
              >
            </div>
            <el-button
              type="primary"
              @click="submit()"
              class="login_button"
              style="width: 296px; height: 46px !important; border-radius: 23px"
              >立即登录</el-button
            >
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessUtil from "@/common/AccessUtil.js";
import request from "@/common/request.js";
import HouseInfo from "@/common/houseInfo.js";
import { error } from "console";

export default {
  data: function () {
    return {
      noSend: false,
      SendCode_text: "获取验证码",
      time_count: 60,
      timer: null,
      smsCode: "",
      isPhone: false,
      basicUrl: process.env.VUE_APP_BASE_URL,
      loginForm: {
        loginName: "",
        password: "",
      },
      rules: {
        loginName: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    "loginForm.loginName": {
      handler(newVal, oldVal) {
        if (
          this.loginForm.loginName === "18586900340" ||
          this.loginForm.loginName === "18585512713"
        ) {
          this.isPhone = !this.isPhone;
        } else {
          this.isPhone = false;
        }
      },
    },
    immediate: true,
    deep: true,
  },
  methods: {
    // 获取验证码
    getCode() {
      let that = this;
      if (!that.timer) {
        request
          .get("/village/web/smsCode?phone=" + this.loginForm.loginName)
          .then((res) => {
            if (res.code === 1) {
              this.noSend = true;
            }
            if (res.code === 0) {
              this.$message({
                type: "error",
                message: "请输入验证码",
              });
            }
          });
        that.timer = setInterval(() => {
          if (that.time_count > 0) {
            that.time_count--;
            that.SendCode_text = "重新发送" + that.time_count + "s";
          } else {
            that.SendCode_text = "获取验证码";
            this.noSend = !this.noSend;
            clearInterval(that.timer);
            that.timer = null;
            that.time_count = 60;
          }
        }, 1000);
      }
    },
    submit() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          if (this.isPhone) {
            if (this.smsCode == "") {
              this.$message({
                type: "error",
                message: "请输入验证码",
              });
              return;
            } else {
              this.loginForm.password = this.$util.encrypt(
                this.loginForm.password
              );
              this.loginForm = {
                username: this.loginForm.loginName,
                password: this.loginForm.password,
              };
              this.loginForm.smsCode = this.smsCode;
            }
          } else {
            this.loginForm.password = this.$util.encrypt(
              this.loginForm.password
            );
            this.loginForm = {
              username: this.loginForm.loginName,
              password: this.loginForm.password,
            };
          }
          request
            .post("/village/web/login", null, this.loginForm)
            .then((response) => {
              if (response.code === 1) {
                console.log(response);
                // debugger
                response = response.data;
                let code = "520000000000";
                if (response.user_level == 2) {
                  code = response.city;
                } else if (response.user_level == 3) {
                  code = response.county;
                } else if (response.user_level == 4) {
                  code = response.town;
                } else if (response.user_level == 5) {
                  code = response.village;
                }

                sessionStorage.setItem("loginName", response.username);
                sessionStorage.setItem("username", response.username);
                sessionStorage.setItem("userPhone", response.phone);
                sessionStorage.setItem("level", response.user_level);
                sessionStorage.setItem("province_name", response.province_name);
                sessionStorage.setItem("city_name", response.city_name);
                sessionStorage.setItem("county_name", response.county_name);
                sessionStorage.setItem("town_name", response.town_name);
                sessionStorage.setItem("village_name", response.village_name);
                sessionStorage.setItem("code", code);
                sessionStorage.setItem(
                  "attribution_code",
                  response.attribution_code
                );
                sessionStorage.setItem(
                  "incrementServicePermissionList",
                  JSON.stringify(response.incrementServicePermissionList)
                );
                // sessionStorage.setItem('loginStatus', null);
                sessionStorage.setItem("user_city", response.city);
                sessionStorage.setItem("user_county", response.county);
                sessionStorage.setItem("user_town", response.town);
                sessionStorage.setItem("user_village", response.village);
                var cityCode = response.city ? response.city : "520000000000";

                window.localStorage.setItem("username", response.username);
                window.localStorage.setItem("level", response.user_level);
                window.localStorage.setItem("city", cityCode);
                window.localStorage.setItem(
                  "provice_name",
                  response.provice_name
                );
                window.localStorage.setItem("city_name", response.city_name);
                window.localStorage.setItem(
                  "county_name",
                  response.county_name
                );
                window.localStorage.setItem("town_name", response.town_name);
                window.localStorage.setItem(
                  "village_name",
                  response.village_name
                );
                window.localStorage.setItem(
                  "attribution_code",
                  response.attribution_code
                );
                window.localStorage.setItem("isSimple", response.isSimple);
                // debugger

                let dataAll = window.AREA_LIST[0].subAddress;
                let dataAllId = [1];
                // for(let i=0; i<dataAll.length; i++){
                //     if(dataAll[i].code == response.city){
                //         dataAllId.push(dataAll[i].id)
                //         let dataAllCounty = dataAll[i].subAddress;
                //         for(let a=0; a<dataAllCounty.length; a++){
                //             if(dataAllCounty[a].code == response.county){
                //                 dataAllId.push(dataAllCounty[a].id)
                //             }
                //         }
                //     }
                // }
                for (let i = 0; i < dataAll.length; i++) {
                  if (dataAll[i].code == response.city_house) {
                    dataAllId.push(dataAll[i].id);
                    let dataAllCounty = dataAll[i].subAddress;
                    for (let a = 0; a < dataAllCounty.length; a++) {
                      if (dataAllCounty[a].code == response.county_house) {
                        dataAllId.push(dataAllCounty[a].id);
                        let dataAllTown = dataAllCounty[a].subAddress;
                        if (dataAllTown && dataAllTown.length > 0) {
                          for (let b = 0; b < dataAllTown.length; b++) {
                            if (dataAllTown[b].code == response.town_house) {
                              dataAllId.push(dataAllTown[b].id);
                              let dataAllvillage = dataAllTown[b].subAddress;
                              for (let c = 0; c < dataAllvillage.length; c++) {
                                if (
                                  dataAllvillage[c].code ==
                                  response.village_house
                                ) {
                                  dataAllId.push(dataAllvillage[c].id);
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                HouseInfo.setAddress(dataAllId);

                let userInfo = response;
                AccessUtil.setAuthToken(userInfo.token);
                // location.href = this.basicUrl + "#/";
                let jump = location.search.split("=")[1];

                if (jump) {
                  location.href = jump;
                } else {
                  location.href = this.basicUrl + "#/";
                }
              } else if (response.code === 0) {
                this.$message({
                  type: "error",
                  message: response.msg,
                });
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<!-- background-image: url(~@/assets/admin_login_bg.png); -->
<style lang="scss">
body {
  margin: 0;
}
</style>
<style lang="scss" scoped>
body {
  margin: 0;
}

.login-box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(~@/assets/login_bg.jpg);
  background-size: 100% 100%;
  /*background-position: center;*/
  background-repeat: no-repeat;

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
  }

  .body {
    position: relative;
    margin: 0 auto;
    /*width: 500px;*/
    /*padding: 60px 40px;*/
    /*border-radius: 5px;*/

    .left {
      position: absolute;
      left: -60px;
      top: 0px;
      width: 592px;
      height: 516px;
      background-image: url(~@/assets/login_bg_left.png);
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
    }

    .right {
      width: 464px;
      height: 516px;
      /* margin-left: 531px; */
      background: #fff;
      border-radius: 5px;
      text-align: center;
      .tips {
        font-size: 28px;
        /* color: #A2A2A2;
                    letter-spacing: 5px; */
        padding-top: 125px;
        color: #000000;
        letter-spacing: 3.12px;
      }
      .el-form {
        padding-top: 30px;
        padding-left: 80px;
        padding-right: 80px;
        .el-form-item {
          position: relative;
          .lable {
            position: absolute;
            top: 3px;
            left: 16px;
            font-size: 18px;
            z-index: 100;
          }
          .el-input {
            border-radius: 20px;
            ::v-deep .el-input__inner {
              height: 40px !important;
            }
            /*.el-input__inner {*/
            /*padding-left: 50px;*/
            /*border-radius: 0;*/
            /*border-top: 0;*/
            /*border-right: 0;*/
            /*border-left: 0;*/
            /*}*/
          }
        }
      }

      .smsCode {
        margin-bottom: 20px;
        width: 304px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
